import { useLayoutEffect } from 'react';

/**
 * Measure the height of the referenced element (expected: mobile bottom nav)
 * and write it to the CSS custom property `--mobile-nav-height`.
 * Adds iOS safe-area inset automatically.
 */
export function useSetMobileNavHeight(ref: React.RefObject<HTMLElement>) {
  useLayoutEffect(() => {
    if (!ref.current) return;

    const setVar = () => {
      const h = ref.current?.offsetHeight || 0;
      const value = `calc(${h}px + env(safe-area-inset-bottom, 0px))`;
      document.documentElement.style.setProperty('--mobile-nav-height', value);
    };

    setVar();

    // Listen for resize events in case orientation changes.
    window.addEventListener('resize', setVar);
    return () => window.removeEventListener('resize', setVar);
  }, [ref]);
} 